import { Unreachable } from '@lemon8/web-app-shared/util';
import { atom } from 'jotai';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';
import { TPOIInfo } from 'shared/models/poi';

type TPOIInfoStore = { [key: string]: TPOIInfo | undefined };

export const $POIInfoStore = atom({} as TPOIInfoStore);

export const $POIInfo = safeAtomFamily((poiId: string) => {
  const a = atom<TPOIInfo, [TPOIInfo], void>(
    (get) => {
      const data = get($POIInfoStore)[poiId];
      if (!data) {
        return Unreachable('no data in $POIInfo');
      }
      return data;
    },
    (get, set, input: TPOIInfo) => {
      const old = get($POIInfoStore);
      set($POIInfoStore, { ...old, [poiId]: input });
    },
  );

  a.debugLabel = `$POIInfo+${encodeURIComponent(poiId)}`;

  return a;
});
